/**
 * @generated SignedSource<<b5780b318665300c67f6effa890885f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkWithMe_userProfile$data = {
  readonly analyticsId: number;
  readonly canReceiveInquiries: boolean;
  readonly generalInquiryCtaIsVisible: boolean;
  readonly id: string;
  readonly visitorCanEdit: boolean;
  readonly visitorChatConversation: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkWithMeLoadedInquiryButton_userProfile">;
  readonly " $fragmentType": "WorkWithMe_userProfile";
};
export type WorkWithMe_userProfile$key = {
  readonly " $data"?: WorkWithMe_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkWithMe_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkWithMe_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "generalInquiryCtaIsVisible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canReceiveInquiries",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatConversation",
      "kind": "LinkedField",
      "name": "visitorChatConversation",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkWithMeLoadedInquiryButton_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "c11b8bfada22f988a00efdc7c8fb47a4";

export default node;
